import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('sspfooter', {
        template: require('./ssp-footer.html'),
        controller: SSPFooter,
        controllerAs: 'vm'
    });

    SSPFooter.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function SSPFooter(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.mainBackground = require('Images/background.png');
        vm.logo = require('Images/nav-logo.png');

        vm.img_rating = require('Images/SSP/rating.png');
        vm.img_change_schedule = require('Images/SSP/change_schedule.png');
        vm.img_complaint = require('Images/SSP/complaint.png');
        vm.img_question = require('Images/SSP/question.png');
        vm.img_receipt = require('Images/SSP/receipt.png');
        vm.img_contact_us = require('Images/SSP/contact_us.png');

        vm.id = $stateParams.id;
        vm.redirectMe = function(route, query) {
            if(query){
                $location.path(route).search({mode: query, id: vm.id});
            }else{
                $location.path(route);
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/ssp-footer/ssp-footer.component.js